import { AuthService } from './../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgForm } from '../../../../node_modules/@angular/forms';

@Component({
  selector: 'app-preservicio',
  templateUrl: './preservicio.component.html',
  styleUrls: ['./preservicio.component.css']
})
export class PreservicioComponent implements OnInit {

  @ViewChild("mensajeError") mensajeError:ElementRef;

  email:string;
  email2:string;
  proteccionDatos:boolean=false;
  proteccionDatos2:boolean=false;

  codigo:string;

  formulario={
    nombre:"",
    email:"",
    tipo:"revisioncontrato",
    pedido: ""
  };



  constructor(private renderer:Renderer2, private expedientesService:ExpedientesService,
              private router:Router, private activatedRoute:ActivatedRoute, private auth:AuthService) {
    if(this.auth.usuarioActivo){
      this.auth.usuarioActivo=null;
      this.auth.loggedIn.next(false);
      localStorage.removeItem("token");
    }
  }

  ngOnInit() {
    this.activatedRoute.queryParams
    .subscribe(params=>{
      this.codigo=params["c"];
    });

    if(this.codigo){
      this.cargarCliente();
    }
  }

  cargarCliente(){
    this.expedientesService.cargarClienteWebServicio(this.codigo)
    .subscribe(resp=>{
      if(resp["err"]==false){
        this.formulario.email=resp["email"];
        this.formulario.pedido="PS"+resp["id"];
      }else{
        window.location.href="https://solucionlegal.es";
      }
    });
  }


  guardarPreservicio(myform:NgForm){
    
    if(this.proteccionDatos){
      if(myform.valid){
        if(this.email===this.email2){
          this.expedientesService.guardarPreservicio(this.email)
          .subscribe(resp=>{
            if(resp["err"]==false){
              alert(resp["msg"]);
              window.top.location.href='https://www.solucionlegal.es/';
            }else{
              let text=this.renderer.createText(resp["msg"]);
              this.renderer.appendChild(this.mensajeError.nativeElement, text);
              this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
            }
          });
        }else{
          let text=this.renderer.createText("Las direcciones de correo introducidas no coinciden.");
          this.renderer.appendChild(this.mensajeError.nativeElement, text);
          this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeError.nativeElement, text);
          }, 1500);
        }
      }else{
        let text=this.renderer.createText("Hay errores en el formulario.");
        this.renderer.appendChild(this.mensajeError.nativeElement, text);
        this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeError.nativeElement, text);
        }, 1500);
      }
    }else{
      let text=this.renderer.createText("Debes aceptar la cláusula de protección de datos.");
      this.renderer.appendChild(this.mensajeError.nativeElement, text);
      this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeError.nativeElement, text);
      }, 1500);
    }
  }

  realizarServicio(myform:NgForm){
    if(this.proteccionDatos2){
      if(myform.valid){
        this.expedientesService.ServicioLegalActivo=this.formulario;
        this.router.navigate(["/consulta", this.formulario.tipo]);
      }else{
        let texto=this.renderer.createText("Hay errores en el formulario.");
        this.renderer.appendChild(this.mensajeError.nativeElement, texto);
        this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeError.nativeElement, texto);
        }, 1500);
      }
    }else{
      let texto=this.renderer.createText("Debes aceptar la cláusula de protección de datos.");
        this.renderer.appendChild(this.mensajeError.nativeElement, texto);
        this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeError.nativeElement, texto);
      }, 1500);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/preservicio/preservicio.component.ts